import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Payee } from '../../../models/payee';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { faUser, faPlus }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-modal-choose-payee',
  templateUrl: './modal-choose-payee.component.html',
styleUrls:  ['./modal-choose-payee.component.css']
})
export class ModalChoosePayeeComponent extends SmsAbstractAppPage implements OnInit {
  faUser = faUser;
  faPlus = faPlus;


  @Output() payee_selected$: EventEmitter<Payee> = new EventEmitter<Payee>();
  @Output() add_new_selected$: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) {
    super();
   }

  ngOnInit() {
  }

  handlePayeeSelection(payee: Payee){
  	this.payee_selected$.emit(payee);
  }

  handleAddNew(){
  	this.add_new_selected$.emit(true);
  }

}
